import {
  TServerErrorResponse,
  UserGuideCompletion,
  UserGuideStatus,
} from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";
import { UserGuideId } from "@/constants/user-guides";

export const USER_GUIDE_COMPLETIONS_GET = "user-guide-completions-get";

/**
 * Every guide the current user has already seen. Absence from the array
 * means the guide has never been shown (there is no NOT_STARTED status).
 */
export const getUserGuideCompletions = async (): Promise<
  UserGuideCompletion[]
> => {
  try {
    const response = await http.get<UserGuideCompletion[]>(
      links.userGuideCompletion.index,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Idempotent upsert of the current user's completion for one guide —
 * last write wins, so repeat calls are safe (no conflict handling needed).
 */
export const putUserGuideCompletion = async (
  guide: UserGuideId,
  status: UserGuideStatus,
): Promise<UserGuideCompletion> => {
  try {
    const response = await http.put<UserGuideCompletion>(
      links.userGuideCompletion.byGuide(guide),
      { status },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
